<template>
  <div>
       <p v-for="p in podcastitems" v-bind:key="p">
      {{ p.title }}
      </p>
  </div>
</template>
<script>
export default {
  name: "Podcastitems",
  props: ["podcastitems"],
}
</script>
